// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"177":"5a3878af","264":"ae920f72","274":"0a146b5b","411":"ba575a80","488":"e9842e4d"}[chunkId] + ".js";
};